import React, { useEffect, useState, useRef } from 'react';
import { LayoutDashboard3col } from '../../layouts/layout-dashboard-3col';
import { Row, Col, Container, Tabs, Tab, Button } from 'react-bootstrap';
import { Nav } from '../../components/nav';
import { Breadcrumb } from '../../components/breadcrumb';
import { useParams } from 'react-router-dom';
import { useAxios } from '../../hooks/useAxios';
import { CombinationWorkflow } from '../../components/combination-workflow';
import { WorkatoConnectors } from '../../components/workato/workato-connectors';
import { SingleWorkatoConnectors } from '../../components/workato/single-workato-connector';
import { Preloader } from '../../components/preloader';
import { RecipeStartStop } from '../../components/workato/button-workato-recipe-start-stop';
import { CombinationSideBar } from '../../components/combination-sidebar';
import { WorkatoConnectinoData } from '../../data/workato/connection-status';
import { Console } from './../../services/platform-api';
import { CombinationInfoPanel } from '../../components/combination-info-panel';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import WFSettings from '../../data/platform/workflow_settings.json';
import Modal from 'react-bootstrap/Modal';

const Combination = (props) => {
  const { data: combinationData = null, fetchNow: setCombinationData } = useAxios();
  const { data: recipeData = null, fetchNow: setRecipeData } = useAxios();
  const [firstload, setFirstload] = useState(true);
  const [refreshRecipe, setRefreshRecipe] = useState(false);
  const [showConnections, setShowConnections] = useState(false);
  const handleClose = () => setShowConnections(false);
  const handleShow = () => setShowConnections(true);

  const [isPreloading, setIsPreloading] = useState(true);
  let { id } = useParams();
  id = parseInt(id);

  const [recipeActive, setRecipeActive] = useState(false);
  const [recipeDisabled, setRecipeDisabled] = useState(false);
  const [recipeDetails, setRecipeDetails] = useState(null);

  const [activeTab, setActiveWFTab] = useState('wf-trigger-1');
  const [WorkflowactiveTab, setWorkflowactiveTab] = useState('workflow');
  const [connectionTab, setConnectionTab] = useState('');
  const [workato_id] = useSessionStorage('workatoId', '');
  const arc_tab_ref1 = useRef(null);
  const arc_tab_ref2 = useRef(null);
  const { cons_data, conns_connected, workato_recipe, isStarterRecipe } = WorkatoConnectinoData(id);

  let workato_recipe_id = null;
  let this_folder_id = null;
  let this_sheet_id = null;
  let recipe_status = null;
  let workato_recipe_webhook = null;

  recipe_status = workato_recipe?.status;
  workato_recipe_id = workato_recipe?.recipe_id;
  workato_recipe_webhook = workato_recipe?.workato_webhook;
  this_folder_id = workato_recipe?.folder_id;
  this_sheet_id = workato_recipe?.sheet_id;

  useEffect(() => {
    if (workato_id === null || workato_id === undefined) return;

    // determin which tab to set as selected on first load
    if (firstload) {
      if (WFSettings.has_trigger.includes(id)) {
        setActiveWFTab('wf-trigger-1');
      } else {
        setActiveWFTab('wf-conn-0');
      }
    }

    // if (id === 1 && firstload === true) setActiveWFTab('wf-trigger-1');
    // if ((id === 168 || id === 9 || id === 12 || id === 13 || id === 15) && firstload === true)
    //   setActiveWFTab('wf-conn-0');

    const headers = {
      'Content-type': 'application/json',
      'x-user-email': 'integrations@arcanum.ai',
      'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
    };

    if (combinationData === null) {
      setCombinationData(`/api/platform/combination/${id}/`, 'GET', null, false);
    }

    if ((workato_recipe_id && recipeData === null) || refreshRecipe) {
      setRecipeData(
        `/api/platform/proxy?url=api/managed_users/${workato_id}/recipes/${workato_recipe_id}`,
        'GET',
        null,
        headers,
      );
      setRefreshRecipe(false);
    } else if (recipeData !== null && combinationData !== null) {
      let merged_data;

      Console('recipeData ', recipeData, 'log');
      // hybrid our combination data with the workato recipe data.
      merged_data = { ...recipeData, ...combinationData };

      setRecipeActive(recipeData?.running);
      setRecipeDetails(merged_data);
      Console('merged data end fo useeffect', merged_data, 'log');
      setIsPreloading(false);
    }
    setFirstload(false);
  }, [id, recipeData, combinationData, workato_recipe_id, WorkflowactiveTab, workato_id, refreshRecipe]);

  if (isPreloading) {
    return <Preloader />;
  }

  // this will refresh our recipe data from above several times
  const refreshTheRecipe = () => {
    setRefreshRecipe(true);
  };

  return (
    <>
      <Modal
        show={showConnections}
        onHide={handleClose}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Setup Connections for Workflows</Modal.Title>
        </Modal.Header>
        <SingleWorkatoConnectors connectionsData={cons_data} connectionTab={connectionTab} />
        <Modal.Footer>
          <Button onClick={handleClose}>Done</Button>
        </Modal.Footer>
      </Modal>

      {recipeDetails && combinationData && workato_id !== 1 ? (
        <div className="dashboard">
          <header>
            <Container fluid>
              <Row>
                <Col lg={6} md={6} className="px-5">
                  <Breadcrumb label={recipeDetails?.sub_title.replace('(basic)', '')} />

                  <h1>{recipeDetails?.name}</h1>
                </Col>
                <Col lg={3} md={3} className="px-5">
                  {/* <BetaRight /> */}
                </Col>

                <Col lg={3} md={3} className="px-5 text-end">
                  {recipe_status === 'complete' && conns_connected ? (
                    <RecipeStartStop
                      recipeStatus={recipeActive}
                      recipeDisabled={recipeDisabled}
                      setRecipeActive={setRecipeActive}
                      recipeID={workato_recipe_id}
                    />
                  ) : recipe_status === 'started' || isStarterRecipe || recipe_status === 'ready' ? (
                    <>
                      <h6 className="pt-4">Loading environment....</h6>
                    </>
                  ) : !conns_connected ? (
                    <>
                      <h6 className="pt-4">First, connect your connectors.</h6>
                    </>
                  ) : recipe_status !== 'complete' && recipe_status !== 'started' ? (
                    <>
                      <h6 className="pt-4">Loading environment....</h6>
                    </>
                  ) : null}
                </Col>
              </Row>
            </Container>
          </header>
          <Container fluid className="px-5">
            <Tabs
              //  activeKey={WorkflowactiveTab}
              className="mb-0"
              onSelect={(WorkflowactiveTab) => setWorkflowactiveTab(WorkflowactiveTab)}
            >
              <Tab eventKey="workflow" title="Workflow">
                <Row>
                  <Col>
                    <LayoutDashboard3col
                      col1={
                        <CombinationWorkflow
                          workflowData={combinationData}
                          arc_tab_ref1={arc_tab_ref1}
                          arc_tab_ref2={arc_tab_ref2}
                          setActiveWFTab={setActiveWFTab}
                          setConnectionTab={setConnectionTab}
                          connectionsData={cons_data}
                          setWorkflowactiveTab={setWorkflowactiveTab}
                          handleShow={handleShow}
                          recipeName={recipeDetails?.name}
                        />
                      }
                      col2={
                        <CombinationInfoPanel
                          workato_recipe_id={workato_recipe_id}
                          arc_tab_ref1={arc_tab_ref1}
                          arc_tab_ref2={arc_tab_ref2}
                          workflowData={combinationData}
                          activeTab={activeTab}
                          webhook_url={workato_recipe_webhook}
                          this_folder_id={this_folder_id}
                          this_sheet_id={this_sheet_id}
                          recipeSetupStatus={recipe_status}
                          recipeActive={recipeActive}
                          connected={conns_connected}
                          refreshTheRecipe={refreshTheRecipe}
                          setRecipeDisabled={setRecipeDisabled}
                        />
                      }
                      sidebar={<CombinationSideBar recipeStatus={recipeActive} recipeDetails={recipeDetails} />}
                    ></LayoutDashboard3col>
                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="connections" title="Connections">
                <WorkatoConnectors connectionsData={cons_data} connectionTab={connectionTab} />
              </Tab>
            </Tabs>
          </Container>

          <Nav nav1on="on" nav2on="" nav3on="" {...props} />
        </div>
      ) : null}
    </>
  );
};

export { Combination };
